import React, { Component } from 'react';
import { base } from '../../base';
import { keyBy, sortBy } from 'lodash';
import User from './User'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'

import Fuse from 'fuse.js'

import './UserList.css';

class UserList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchTerm: ''
        }
    }

    componentDidMount() {
            base.listenToCollection('users', {
            context: this,
            then: this.groupData,
            withIds: true
        })
    }

    groupData(data) {
        const users = sortBy(data, (user) => user.id)
        this.setState({
            userMap: keyBy(data, (user) => user.id),
            users,
            startingUserArray: users
        })
    }

    onSearch = (searchTerm) => {
        if (searchTerm === '') {
            this.setState({
                users: this.state.startingUserArray,
                searchTerm: ''
            })
            return
        }

        const options = {
            caseSensitive: false,
            threshold: 0.3, // magic number to play with
            sort: true,
            maxPatternLength: 24,
            minMatchCharLength: 2,
            keys: ['id']
        }

        const fuse = new Fuse(this.state.users, options)
        this.setState({
            searchTerm,
            users: fuse.search(searchTerm),
        })
    }

    render() {
        const { users, searchTerm } = this.state
        if (users == null) {
            return <div>Loading...</div>
        }

        return (
            <div className="user-list">
                <TextField
                    className="search"
                    value={searchTerm}
                    onChange={(e) => this.onSearch(e.target.value)}
                    placeholder="Search..."
                />
                <Grid container={true} spacing={8}>
                    {users && users.map(user => (
                        <Grid key={user.id} item={true} xs={12} sm={6} md={4}>
                            <User user={user} />
                        </Grid>
                    ))}
                </Grid>
            </div>
        )
    }
}

export default UserList;



// WEBPACK FOOTER //
// ./src/components/User/UserList.js